/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import { HttpClient } from "./http-client";
export class Revision extends HttpClient {
    /**
     * No description
     *
     * @name GetFrontendIr
     * @summary Get frontend IR
     * @request GET:/{revision}/gen.{locale}.frontend.ir.json
     */
    getFrontendIr = ({ revision, locale }, params = {}) => this.request({
        path: `/${revision}/gen.${locale}.frontend.ir.json`,
        method: "GET",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name GetScripts
     * @summary Get processing scripts
     * @request GET:/{revision}/gen.scripts.json
     */
    getScripts = ({ revision }, params = {}) => this.request({
        path: `/${revision}/gen.scripts.json`,
        method: "GET",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name GetClientAreaIr
     * @summary Get Client Area IR
     * @request GET:/{revision}/gen.{locale}.client_area.ir.json
     */
    getClientAreaIr = ({ revision, locale }, params = {}) => this.request({
        path: `/${revision}/gen.${locale}.client_area.ir.json`,
        method: "GET",
        format: "json",
        ...params,
    });
}
//# sourceMappingURL=Revision.js.map